import { GAME_TYPES, USER_STATUS } from "./util";

if (window.location.pathname.split("/").pop() === "" && window.location.hash) {
  $("html,body").scrollTop(600);
  const targetButtons = window.location.hash.slice(1);

  if (GAME_TYPES.includes(targetButtons)) {
    $(".featured-products.active").removeClass("active");
    $(`.${targetButtons}-buttons`).addClass("active");
  }
}

$(".featured-products-pagination-right").on("click", () => {
  const currentGroup = $(".featured-products.active");
  const currentPage = currentGroup.find(".featured-products-pagination-page.page-active");
  const nextPage = currentPage.next(".featured-products-pagination-page");

  if (nextPage.length) {
    currentPage.removeClass("page-active");
    nextPage.addClass("page-active");

    currentGroup
      .find(".featured-products-buttons-container")
      .animate({ "margin-right": "+=100%", "margin-left": "-=100%" });

    currentGroup.find(".featured-products-buttons.active").removeClass("active").next().addClass("active");
  }
});

$(".featured-products-pagination-left").on("click", () => {
  const currentGroup = $(".featured-products.active");
  const currentPage = currentGroup.find(".featured-products-pagination-page.page-active");
  const prevPage = currentPage.prev(".featured-products-pagination-page");

  if (prevPage.length) {
    currentPage.removeClass("page-active");
    prevPage.addClass("page-active");

    currentGroup
      .find(".featured-products-buttons-container")
      .animate({ "margin-right": "-=100%", "margin-left": "+=100%" });

    currentGroup.find(".featured-products-buttons.active").removeClass("active").prev().addClass("active");
  }
});

$(".featured-products-pagination-page").on("click", function (event) {
  const selectedPage = $(event.target);

  if (selectedPage.hasClass("page-active")) {
    return;
  }

  if (selectedPage.prevAll(".featured-products-pagination-page.page-active").length) {
    $(this).siblings(".featured-products-pagination-right").trigger("click");
  } else {
    $(this).siblings(".featured-products-pagination-left").trigger("click");
  }

  $(this).trigger("click");
});

const featuredProductGroups = ["jsc", "kuaikai", "shishi", "cn", "hot", "hk", "sports", "qipai", "dianzi"];

featuredProductGroups.forEach((productGroupItem) => {
  $(`.${productGroupItem}-view`).on("click", () => {
    $(".featured-products.active").removeClass("active");
    $(`.${productGroupItem}-buttons`).addClass("active");
    window.location.hash = productGroupItem;
  });
});

$(".footer-link.featured-product").on("click", (event) => {
  if (window.location.pathname.split("/").pop() === "") {
    event.preventDefault();
    $("html,body").animate({ scrollTop: 600 });
    $(".featured-products.active").removeClass("active");
    $(`.${event.target.attributes.href.value.slice(2)}-buttons`).addClass("active");
  }
});

$(".featured-products-buttons .featured-product a").on("click", (e) => {
  e.preventDefault();
  const isLoggedIn = $(".before-login.hide").length !== 0;
  const newTabUrl = e.currentTarget.attributes.newTabUrl?.value;

  if (isLoggedIn && window.isGuest === 1 && newTabUrl) {
    window.open(newTabUrl);
    return;
  }

  if (isLoggedIn && window.userStatus === USER_STATUS.FREEZE_MONEY) {
    return alertBox({
      message: "抱歉! 你的资金已被冻结(只限查看明细可用), 请和上级联系。",
      type: "error",
    });
  }

  if (isLoggedIn && window.userStatus === USER_STATUS.FORBID_BETTING) {
    return alertBox({
      message: "抱歉! 你的账号已被冻结(只限结账功能可用), 请和上级联系。",
      type: "error",
    });
  }

  if (isLoggedIn) {
    location.href = e.currentTarget.href;
    return;
  }

  $("#modal-signup").addClass("active");
});
